<template>
  <div class="reply-wrap">
    <template v-if="showOneReply && showReply">
      <ReplyItem
        v-for="(r, i) in replyList.slice(0, displayCount)"
        :key="'reply-content-' + r.id"
        class="reply-one"
        :info="r"
        :masterUuid="masterUuid"
        @replycomment="$emit('replycomment', $event)"
        @deletereply="$emit('deletereply', {
          index: i,
          replyId: $event,
        })"
      />
    </template>
    <template v-else>
      <ReplyItem
        v-for="(r, i) in replyList"
        :key="'reply-content-' + r.id"
        class="reply-one"
        :info="r"
        :masterUuid="masterUuid"
        @replycomment="$emit('replycomment', $event)"
        @deletereply="$emit('deletereply', {
          index: i,
          replyId: $event,
        })"
      />
    </template>
    <template v-if="count > displayCount && !loading && showReply">
      <button v-show="showOneReply" class="show-all" @click="getReply">查看回覆（{{ count }}）</button>
      <button v-show="!showOneReply" class="show-all" @click="showOneReply = true">收起回覆</button>
    </template>
    <div v-if="loading" class="loading-wrap">
      <i class="el-icon-loading" />
    </div>
  </div>
</template>
<script>
import ReplyItem from './reply-item'
import { getReplyList } from './moment'
export default {
  components: {
    ReplyItem,
  },
  model: {
    prop: 'count',
    event: 'change',
  },
  props: {
    count: Number,
    replyList: {
      type: Array,
      default: () => [],
    },
    masterUuid: String,
    showReply: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOneReply: true,
      loading: false,
      displayCount: 2,
    }
  },
  created() {

  },
  methods: {
    async getReply() {
      if (this.replyList.length === this.displayCount && !this.loading) {
        this.loading = true
        try {
          const { data } = await getReplyList({
            commentId: this.replyList[0].commentId,
            size: 50,
          })
          this.$emit('updatereply', data)
          this.loading = false
        } catch (e) {
          console.log(e)
          this.loading = false
          return
        }
      }
      this.showOneReply = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .reply-wrap {
    width: 100%;
    background: #F9F9F9;
    border-radius: 8px;
    padding: 12px;
    .reply-one:not(:first-child) {
      margin-top: 8px;
    }
  }
  .show-all {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
    color: $color-gray-3;
  }
</style>
